module.exports = __webpack_public_path__ + "static/img/rz(4).f12bb2ed.jpg";